import {
  Building2,
  ClipboardList,
  LayoutGrid,
  Paperclip,
  Tags,
  Users,
  UsersRound,
  type LucideIcon
} from 'lucide-react'

import { CategoryEnum } from 'src/api/main'

export const ROLES_LIST_PAGE_SIZE = 200
export const MEMBERS_LIST_PAGE_SIZE = 200

export const OWNER_ROLE_CODENAME = 'main-owner'
export const ADMIN_ROLE_CODENAME = 'main-admin'

export const isOwnerRole = (codename?: string | null): boolean =>
  codename === OWNER_ROLE_CODENAME

/**
 * Display order for the workspace permission catalog, mirroring the backend
 * enum's own order (workspace-wide scope first, audit last). Categories the
 * backend adds later fall to the end and sort by label.
 */
export const PERMISSION_CATEGORY_ORDER: readonly CategoryEnum[] = [
  CategoryEnum.ORGANIZATION,
  CategoryEnum.USERS,
  CategoryEnum.ROLES,
  CategoryEnum.GROUPS,
  CategoryEnum.APPLICATIONS,
  CategoryEnum.ATTACHMENTS,
  CategoryEnum.AUDIT
]

/**
 * Palette used to color role chips. The role's id (or codename) is hashed
 * into the array — keeps the visual identity stable across renders.
 */
export const ROLE_COLOR_PALETTE = [
  '#0F766E',
  '#2563EB',
  '#7C3AED',
  '#DC2626',
  '#0E9F6E',
  '#D97706',
  '#5B6675',
  '#0B1420'
] as const

export const pickRoleColor = (seed: string | number): string => {
  const text = String(seed)
  let hash = 0
  for (let i = 0; i < text.length; i += 1) {
    hash = (hash * 31 + text.charCodeAt(i)) | 0
  }
  const idx = Math.abs(hash) % ROLE_COLOR_PALETTE.length

  return ROLE_COLOR_PALETTE[idx] ?? ROLE_COLOR_PALETTE[0]
}

/**
 * Icon per permission category — used by the catalog's category filter and its
 * Category column so a row is recognisable before reading the label. Mirrors
 * the sidebar's icon choices for the same concepts (members, roles, apps,
 * audit) so the vocabulary stays consistent across the app.
 */
export const PERMISSION_CATEGORY_ICON: Record<CategoryEnum, LucideIcon> = {
  [CategoryEnum.ORGANIZATION]: Building2,
  [CategoryEnum.USERS]: Users,
  [CategoryEnum.ROLES]: Tags,
  [CategoryEnum.GROUPS]: UsersRound,
  [CategoryEnum.APPLICATIONS]: LayoutGrid,
  [CategoryEnum.ATTACHMENTS]: Paperclip,
  [CategoryEnum.AUDIT]: ClipboardList
}
